<template>
    <div class="card">
        <div class="pb-0 card-header mb-0">
            <h6>Perangkat per Tahun Online</h6>
        </div>
        <div class="p-3 card-body">
            <div class="chart">
                <canvas id="chart-line2" class="chart-canvas" height="300"></canvas>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import Chart from "chart.js/auto";
import { onMounted, ref } from "vue";
import { ApiService } from "@/axios/apiService";

const apiService = new ApiService();
const label = ref('');
const data = ref('');

const chart = () => {
    let ctx1 = document.getElementById("chart-line2").getContext("2d");
    new Chart(ctx1, {
        type: "bar",
        data: {
            labels: label.value,
            datasets: [
                {
                    label: "Perangkat",
                    backgroundColor: "#4E85E3",
                    data: data.value,
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
            },
            interaction: {
                intersect: false,
                mode: "index",
            },
            scales: {
                y: {
                    grid: {
                        drawBorder: false,
                        display: true,
                        drawOnChartArea: true,
                        drawTicks: false,
                        borderDash: [5, 5],
                    },
                    ticks: {
                        display: true,
                        padding: 10,
                        color: "#000",
                        font: {
                            size: 14,
                            family: "Open Sans",
                            style: "normal",
                            lineHeight: 2,
                        },
                    },
                },
                x: {
                    grid: {
                        drawBorder: false,
                        display: false,
                        drawOnChartArea: false,
                        drawTicks: false,
                        borderDash: [5, 5],
                    },
                    ticks: {
                        display: true,
                        color: "#000",
                        padding: 20,
                        font: {
                            size: 14,
                            family: "Open Sans",
                            style: "normal",
                            lineHeight: 2,
                        },
                    },
                },
            },
        },
    });
};

onMounted(async()=>{
    const data_ = await apiService.perangkatTahunOnline();
    data.value = data_.data.map(a=>a.total);
    label.value = data_.data.map(a=>a.year);
    chart();
});
</script>
  